<template>
  <a-modal
    title="处理结果"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    okText="确认"
    cancelText="取消"
    :confirmLoading="confirmLoading"
  >
    <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
      <a-form-model-item prop="status">
        <a-radio-group name="status" v-model="form.status">
          <a-radio :value="2">无需处理</a-radio>
          <a-radio :value="1">处理完成</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { handleDiscoveryReport } from '@/api/discovery/discoveryReport'

export default {
  name: 'HandleModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        id: undefined,
        reportType: undefined,
        contentId: undefined,
        status: 2
      },
      rules: {
        status: [
          { required: true, message: '状态' + this.$t('不能为空'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    openModal(id, contentId, reportType) {
      this.visible = true
      this.confirmLoading = false
      this.form.id = id
      this.form.contentId = contentId
      this.form.reportType = reportType
    },
    handleOk() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        this.confirmLoading = true
        handleDiscoveryReport(this.form).then(res => {
          this.$emit('ok')
          this.handleCancel()
        })
      })
    },
    handleCancel() {
      this.resetForm()
      this.visible = false
      this.confirmLoading = false
    },
    resetForm() {
      this.$refs.form.resetFields()
    }
  }
}
</script>